export default __webpack_public_path__ + "static/montserrat-v18-latin-regular-b07bcc994632839adaff56a67b143cf1.woff2";